<!-- Created by henian.xu on 2020/5/22. -->

<template>
    <div class="edit-work-history">
        <el-form
            ref="form"
            class="el-table el-table--small"
            size="small"
            :model="formModel"
            :rules="formRules"
        >
            <table>
                <thead>
                    <tr>
                        <th><div class="cell">开始日期</div></th>
                        <th><div class="cell">结束日期</div></th>
                        <th><div class="cell">工作岗位</div></th>
                        <th><div class="cell">工作单位</div></th>
                        <th><div class="cell">操作</div></th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="(item,index) in formModel"
                        :key="index"
                    >
                        <td>
                            <div class="cell">
                                <el-form-item
                                    :prop="`${index}.startDate`"
                                    :rules="formRules.required">
                                    <el-date-picker
                                        type="date"
                                        v-model="item.startDate"
                                        format="yyyy年MM月dd日"
                                        value-format="yyyy年MM月dd日"
                                    />
                                </el-form-item>
                            </div>
                        </td>
                        <td :width="item.isSoFar?'150':'330'">
                            <div class="cell">
                                <el-form-item
                                    :prop="item.isSoFar?`${index}.isSoFar`:`${index}.endDate`"
                                    :rules="formRules.required">
                                    <el-switch
                                        v-model="item.isSoFar"
                                        active-color="#13ce66"
                                        inactive-color="#ff4949"
                                        :active-value="1"
                                        :inactive-value="0"
                                        active-text="至今"
                                    ></el-switch>
                                    <el-date-picker
                                        class='ma-l'
                                        type="date"
                                        v-if='!item.isSoFar'
                                        :value="item.endDate===-1?'':item.endDate"
                                        @input="(e)=>item.endDate = e"
                                        format="yyyy年MM月dd日"
                                        value-format="yyyy年MM月dd日"
                                    />
                                </el-form-item>
                            </div>
                        </td>
                        <td>
                            <div class="cell">
                                <el-form-item
                                    :prop="`${index}.profession`"
                                    :rules="formRules.required">
                                    <el-input v-model="item.profession"/>
                                </el-form-item>
                            </div>
                        </td>
                        <td>
                            <div class="cell">
                                <el-form-item
                                    :prop="`${index}.companyName`"
                                    :rules="formRules.required">
                                    <el-input v-model="item.companyName"/>
                                </el-form-item>
                            </div>
                        </td>
                        <td>
                            <div class="cell">
                                <el-button
                                    type="text"
                                    size="small"
                                    @click="onDel(item,index)"
                                >
                                    删除
                                </el-button>
                            </div>
                        </td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <td colspan="100">
                            <div class="cell">
                                <el-button
                                    v-if="!maxCount||(maxCount && formModel.length<maxCount)"
                                    type="success"
                                    icon="el-icon-plus"
                                    size="small"
                                    @click="onAdd"
                                >
                                    添加经历
                                </el-button>
                                <div
                                    v-else-if="maxCount"
                                    class="tc-minor">最多添加 {{maxCount}} 条</div>
                            </div>
                        </td>
                    </tr>
                </tfoot>
            </table>
        </el-form>
    </div>
</template>

<script>
import emitter from 'element-ui/src/mixins/emitter';

export default {
    name: 'EditWorkHistory',
    mixins: [emitter],
    data() {
        return {
            formModel: [],
            formRules: {
                required: {
                    required: true,
                    message: '不能为空',
                },
            },
            onConfirm_: null,
            innerCtrl__: false,
        };
    },
    props: {
        value: {
            type: Array,
            default: () => [],
        },
        placeholder: {
            type: String,
            default: '添加经历',
        },
        maxCount: {
            type: Number,
            default: 0,
        },
    },
    computed: {
        model: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
                this.dispatch('ElFormItem', 'el.form.change', [val]);
            },
        },
        fields() {
            return this.$refs.form.fields;
        },
    },
    watch: {
        formModel: {
            handler() {
                if (!this.onConfirm_) {
                    this.onConfirm_ = this.$utils.debounce(this.onConfirm, 500);
                }
                this.onConfirm_();
            },
            deep: true,
        },
        model: {
            handler(val) {
                if (this.innerCtrl__) {
                    this.innerCtrl__ = false;
                    return;
                }
                try {
                    this.formModel = JSON.parse(JSON.stringify(val));
                } catch (e) {
                    // noop
                }
            },
            immediate: true,
        },
    },
    methods: {
        onAdd() {
            this.formModel.push({
                startDate: '', // 开始时间
                endDate: '', // 结束时间
                isSoFar: 1, // 值为:1;0
                profession: '', // 职业
                companyName: '', // 所在单位
            });
        },
        onDel(item, index) {
            this.formModel.splice(index, 1);
        },
        async validate(callback) {
            return this.$refs.form.validate(callback);
        },
        async onConfirm() {
            await this.validate();
            this.innerCtrl__ = true;
            this.model = [...this.formModel];
        },
    },
};
</script>

<style lang="scss">
.edit-work-history {
    > .el-table {
        > table {
            width: 100%;
            border-collapse: collapse;

            tr {
                > th,
                > td {
                    border: 1px solid $color-border;
                }
            }
        }
    }
}
</style>
